/***********************************************************
 Tabs Middleware
 --------------------------
 Middleware to apply a tabs navigation animation to pages with a main tabs layout.
 ************************************************************/
export default defineNuxtRouteMiddleware((to, from) => {
    try {
        // Handle transitions when navigating between main routes of the same model via tabs
        let toIndex = -1;
        let fromIndex = -1;

        // Within 'matched' we receive every page component (might be multiple for nested routes, e.g., participations)
        const pageComponents = to.matched;
        if (pageComponents?.length) {

            // Iterate over every page component to find the one which manages the tabs the user is currently navigating on
            for (let i = 0; i < pageComponents.length; i++) {
                // We are only interested in page components that manage a 'tabRoutes' prop
                const tabsPathOrder: string[] = pageComponents[i].meta?.tabsPathOrder ?? [];
                if (tabsPathOrder?.length) {
                    toIndex = tabsPathOrder.findIndex(path => path === to.path);
                    fromIndex = tabsPathOrder.findIndex(path => path === from.path);

                    if (toIndex > -1) {
                        break;
                    }
                }
            }
        }

        // We only use a tab page transition when navigating from a tab sub-page to another sub-page using the tabs
        if (toIndex < 0 || fromIndex < 0) {
            return;
        }

        if (toIndex > fromIndex) {
            to.meta.pageTransition = {
                name: 'tab-page-enter-from-right-transition',
                mode: 'out-in'
            };
            from.meta.pageTransition = {
                name: 'tab-page-enter-from-left-transition',
                mode: 'out-in'
            };
        } else if (toIndex < fromIndex) {
            to.meta.pageTransition = {
                name: 'tab-page-enter-from-left-transition',
                mode: 'out-in'
            };
            from.meta.pageTransition = {
                name: 'tab-page-enter-from-right-transition',
                mode: 'out-in'
            };
        }
    } catch (e) {
        // We do not want to break the navigation if the tabs middleware fails
        console.error(e);
    }
})